import React from 'react';
import { browserHistory } from 'react-router';
import Body from './Body';
import AllEvents from './AllEvents';
import EventInfo from './EventInfo';
import CelebrityInfo from './CelebrityInfo';
import EditEventInfo from './EditEventInfo';
import EditAdminCelebratedInfo from '../../EditAdminCelebratedInfo';
import ConfirmDeleteOwnerPopUp from './ConfirmDeleteOwnerPopUp';
import commonUtil from './../../../../../../utils/commonUtil';
// import ModalPopover from '../../../../../../components/ZUILib/ModalPopover';
// import AppEvents from './../../../../../App/AppEvents';

const applicationRoutes = commonUtil.getApplicationRoutes();


class WapDatosDeMiEvento extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showOtherActiveEvent: false,
      ownerForDelete: '',
    };
    // this.getEventTokenEvent = AppEvents.subscribe(AppEvents.EVENT_REGISTER.GET_EVENT_TOKEN);
    // this.wapBackButtonEvent = null;
  }
  // showEditEventNameSection = () => {
  //   const box = document.querySelector('.editEventName');
  //   let winWidth = window.innerWidth;
  //   box.style.left = winWidth + 'px';
  //   winWidth -= 1;
  //   box.style.left = 0 + 'px';
  // }

  // back button functionality
  // componentWillUnmount() {
  //   AppEvents.unsubscribe(this.getEventTokenEvent);
  //   AppEvents.unsubscribe(this.wapBackButtonEvent);
  // }
  // componentDidMount() {
  //   if (this.eventId && this.getEventTokenEvent) {
  //     AppEvents.publish(this.getEventTokenEvent, [this.eventId]);
  //   }
  //   this.wapBackButtonEvent = AppEvents.subscribe(AppEvents.EVENT_REGISTER.WAP_BACK_BUTTON_CLICKED);
  //   if (this.wapBackButtonEvent) {
  //     AppEvents.publish(this.wapBackButtonEvent, [this.showPreviousSection()]);
  //   }
  // }
  //  // add function for WAP event management
  // showPreviousSection = () => {
  //   const menu = document.querySelector('.editEventName');
  //   const showCelebrityMenu = document.querySelector('.myEventContent.showCelebrity');
  //   const myEventsMenu = document.querySelector('.myEventsMenu');
  //   const innerWidth = window.innerWidth + 'px';
  //   if (menu && menu.style.left === '0px') {
  //     menu.style.left = innerWidth;
  //   } else if (showCelebrityMenu && showCelebrityMenu.style.left === '0px') {
  //     showCelebrityMenu.style.left = innerWidth;
  //   } else if (myEventsMenu && myEventsMenu.style.left === '0px') {
  //     myEventsMenu.style.left = innerWidth;
  //   } else if (this.externalClickHandlerForWapBackButton && typeof this.externalClickHandlerForWapBackButton === 'function') {
  //     this.externalClickHandlerForWapBackButton();
  //   }
  // }

  showEditEventNameSection = () => {
    const menu = document.querySelector('.editEventName');
    this.windwidth -= 1;
    menu.style.left = 0 + 'px';
    const eventNameErrorTag = document.querySelector('.editEventName .formBlock > .error');
    const eventNameErrorLabelTag = document.querySelector('.editEventName .formBlock .inputMaterial.error');
    if (eventNameErrorTag && eventNameErrorLabelTag) {
      eventNameErrorTag.textContent = '';
      eventNameErrorLabelTag.classList.remove('error');
    }
    if (document.querySelector('.alertError')) {
      document.querySelector('.alertError').style.display = 'none';
    }
  }

  showCelebityEditingSection = () => {
    const box = document.querySelector('#editAdminCelebratedInfoModal');
    let winWidth = window.innerWidth;
    box.style.left = winWidth + 'px';
    winWidth -= 1;
    box.style.left = 0 + 'px';
    this.props.showWapEditingSection();
    // if (this.shareModal.handleShow) {
    //   this.shareModal.handleShow();
    // }
  }
  hideCelebityEditingSection = () => {
    if (document.querySelector('#editAdminCelebratedInfoModal')) {
      const box = document.querySelector('#editAdminCelebratedInfoModal');
      let winWidth = window.innerWidth;
      box.style.left = winWidth + 'px';
      winWidth += 1;
      box.style.left = winWidth + 'px';
      // note : this is for setting the state of edit mode
      if (this.props.isAddingAndEditingNewCoOwnerMode) {
        this.props.handleCancelEditingAndAdding('wapCelebrityInfoDisplayMode');
      }
      // if (this.shareModal.handleHide) {
      //   this.shareModal.handleHide();
      // }
    }
  }
  showOtherActiveEventSection = () => {
    // const box = document.querySelector('.myEventsMenu');
    // box.style.opacity = 1;
    // let winWidth = window.innerWidth;
    // box.style.left = winWidth + 'px';
    // winWidth -= 1;
    // box.style.left = 0 + 'px';
    window.scrollTo(0, 0);
    const menu = document.querySelector('.myEventsMenu');
    this.windwidth -= 1;
    menu.style.left = 0 + 'px';
    menu.style.opacity = 1;
    menu.style.height = innerHeight + 'px';
  }
  hideOtherActiveEventSection = () => {
    const box = document.querySelector('.myEventsMenu');
    box.style.opacity = 0;
    let winWidth = window.innerWidth;
    box.style.left = winWidth + 'px';
    winWidth += 1;
    box.style.left = winWidth + 'px';
  }
  handleSelectedOwner = (celebrity) => {
    this.props._handleEditOwnerInformation(celebrity);
  }
  switchToAddingNewCoOwner = () => {
    this.props.handleCancelEditingAndAdding('addingNewCoOwner');
  }

  getActiveEventInfo = (event) => {
    const user = this.props.user;
    this.props.handleCancelEditingAndAdding('loadNewEvent');
    this.props.getEventDetails(event.eventId, user.result.profileId);
    browserHistory.push(commonUtil.getRouteByParameter(applicationRoutes.eventManagement, { pageName: 'DatosDeMiEvento', eventID: event.eventId }));
    this.hideOtherActiveEventSection();
  }
  confirmationAcceptedCB = () => {
    this.adminDetail.deleteCoOwner(this.deleteCelebrity, this.eventId);
    this.confirmationRejectedCB();
  }
  confirmationRejectedCB = () => {
    this.modal.handleHide();
    this.eventId = '';
    this.deleteCelebrity = '';
    this.setState({
      ownerForDelete: '',
    });
  }
  deleteModal = (celebrityInfo, eventId) => {
    this.deleteCelebrity = celebrityInfo;
    this.eventId = eventId;
    this.setState({
      ownerForDelete: celebrityInfo,
    });
    this.modal.handleShow();
  }
  render() {
    const { eventDetailsInfo } = this.props;
    const eventStatusForSuspended = this.props.eventStatusForSuspended;
    const activeEventsInfo = eventDetailsInfo && eventDetailsInfo.activeEventsInfo ? eventDetailsInfo.activeEventsInfo : null;
    const activeEvents = [];
    const selectedEventConfiguration = this.props.selectedEventConfiguration;
    if (!activeEventsInfo) {
      return false;
    }
    const saveButton = {
      name: 'Guardar',
      type: 'button',
      value: 'Guardar',
      disabled: false,
      autoFocus: false,
      style: 'btnPrimaryAction',
      onClickHandler: this.updateEventName,
    };
    /* eslint-disable */
    for (const i in activeEventsInfo) {
      const _activeEvent = {};
      _activeEvent.displayName = activeEventsInfo[i];
      _activeEvent.route = '#';
      _activeEvent.eventId = i;
      activeEvents.push(_activeEvent);
    };
    /* eslint-enable */
    const otherEventData = activeEvents.map((activeEvent, id) =>
      <li key={id}>
        <a
          href="javascript:void(0)"
          onClick={() => { this.getActiveEventInfo(activeEvent); }}
        > {activeEvent.displayName}
          <i className="icon-flecha_lightsvg_derecha" />
        </a>
      </li>);
    if (eventDetailsInfo) {
      return (
        <div
          className="position-rela"
          ref={
            (element) => {
              if (element) { element.style.setProperty('height', '80vh', 'important'); }
            }}
        >
          {(this.props.celebrityInfo || this.props.isAddingAndEditingNewCoOwnerMode) ?
            <EditAdminCelebratedInfo
              ref={edit => this.editAdmin = edit}
              _newCoOwnerAddedResponseCallback={this.props._newCoOwnerAddedResponseCallback}
              getEventDetails={this.props.getEventDetails}
              isAddingNewCoOwnerMode={this.props.isAddingAndEditingNewCoOwnerMode}
              hideCelebityEditingSection={this.hideCelebityEditingSection}
              celebrityInfo={this.props.celebrityInfo}
              showCelebityEditingSection={this.showCelebityEditingSection}
              selectedEventConfiguration={selectedEventConfiguration}
            />
            : null}
          <AllEvents otherActiveEvents={otherEventData} />
          <ConfirmDeleteOwnerPopUp
            lables={this.props.lables}
            ref={modal => this.modal = modal}
            confirmationAcceptedCB={this.confirmationAcceptedCB}
            confirmationRejectedCB={this.confirmationRejectedCB}
            celebrity={this.state.ownerForDelete}
          />
          <EditEventInfo
            eventID={this.props.eventID}
            _getEventDetails={this.props._getEventDetails}
            eventDetailsInfo={eventDetailsInfo}
            handleSaveEventNickName={this.props.handleSaveEventNickName}
            userEventDetails={this.props.userEventDetails}
            handleValidateEventName={this.props.handleValidateEventName}
            eventStatusForSuspended={eventStatusForSuspended}
          />
          <EventInfo
            eventDetailsInfo={eventDetailsInfo}
            showEditEventNameSection={this.showEditEventNameSection}
            saveButton={saveButton}
            {...this.state}
            eventID={this.props.eventID}
            _getEventDetails={this.props._getEventDetails}
            lables={this.props.lables}
            eventStatusForSuspended={eventStatusForSuspended}
          />
          <Body
            showOtherActiveEventSection={this.showOtherActiveEventSection}
            eventDetailsInfo={eventDetailsInfo}
            showOtherEvents={this.showOtherEvents}
            handleSelectedOwner={this.handleSelectedOwner}
            {...this.state}
            switchToAddingNewCoOwner={this.switchToAddingNewCoOwner}
            user={this.props.user}
            checkEventEligibleToCreate={this.props.checkEventEligibleToCreate}
            eventStatusForSuspended={eventStatusForSuspended}
            selectedEventConfiguration={selectedEventConfiguration}
          />
          <CelebrityInfo
            deleteModal={this.deleteModal}
            ref={adminDetail => this.adminDetail = adminDetail}
            resetCelebrityAfterDelete={this.props.resetCelebrityAfterDelete}
            seletedCelebrity={this.props.celebrityInfo}
            showCelebityEditingSection={this.showCelebityEditingSection}
            removeCoOwner={this.props.removeCoOwner}
            _getEventDetails={this.props._getEventDetails}
            eventID={this.props.eventID}
            eventStatusForSuspended={eventStatusForSuspended}
            selectedEventConfiguration={selectedEventConfiguration}
          />
        </div >
      );
    }
    return null;
  }
}

export default WapDatosDeMiEvento;
